// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+kprg","loader":"styles_loader__99WOP","spin":"styles_spin__DTaGQ"};